import { render, staticRenderFns } from "./ListPickupRequests.vue?vue&type=template&id=74ec2616&scoped=true&lang=pug"
import script from "./ListPickupRequests.vue?vue&type=script&lang=js"
export * from "./ListPickupRequests.vue?vue&type=script&lang=js"
import style0 from "./ListPickupRequests.vue?vue&type=style&index=0&id=74ec2616&prod&lang=scss&scoped=true"
import style1 from "./ListPickupRequests.vue?vue&type=style&index=1&id=74ec2616&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ec2616",
  null
  
)

export default component.exports